// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__x-Tad","title":"Info_title__4Alvf","links":"Info_links__1YsFf","link":"Info_link__11Cy_","logo":"Info_logo__g9hVZ"};